import { Pipe, PipeTransform, inject, effect, ChangeDetectorRef } from '@angular/core';
import {isObservable, Subscription} from 'rxjs';
import { TextResourceService } from '../services/session/text-resource.service';
import { NGXLogger } from 'ngx-logger';

@Pipe({
  name: 'txtResPipe',
  standalone: true
})
export class TxtResPipe implements PipeTransform {

  readonly textResourceService = inject(TextResourceService);
  private readonly logger = inject(NGXLogger);


  onTranslationChange: Subscription | undefined;

  constructor(private _ref: ChangeDetectorRef) {
    // effect(() => { 
    //   const value = this.textResourceService.getCurrentLang(); 
    //   console.log('Signal value changed:', value); 
    // });

  }


  transform(key: any, items: Map<string,string>, args?: any): any {
    console.log('TxtResPipe', key);
    console.log('items', items);

    // let xx = effect(() => { 
    //   const value = this.textResourceService.getCurrentLang(); 
  
    //   console.log('Signal value changed:', value); 
    // });

    // this.onTranslationChange = this.translate.onTranslationChange.subscribe((event: TranslationChangeEvent) => {
    //   if (this.lastKey && event.lang === this.translate.currentLang) {
    //     this.lastKey = null;
    //     this.updateValue(query, interpolateParams, event.translations);
    //   }
    // });   
  
    if (items) {
      if (items.has(key)) {
        return items.get(key);
      }
    }
    return key;
  }

}
